import {Component, EventEmitter, Input, Output} from '@angular/core'

@Component({
  selector: 'dmmp-events-section',
  templateUrl: './events-section.component.html'
})
export class EventsSectionComponent {

  @Input() module
  @Input() data
  @Input() identifier
  @Output() redirectPage = new EventEmitter()

  constructor() {
  }
}
